import { Observable } from "rxjs/Observable";
import * as actions from "./control.actions";
import { Control } from "./control.model";
import { Group } from "../group/group.model";
import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";
import { isInArray } from "../../../core/util/is-in-array";

export class ControlStoreFacade extends RestrictedAccountObjectStoreFacade<Control> {

    getAll(): Observable<Array<Control>> {
        return this.select(Qry.getInstance().control.byActiveAccount);
    }

    create(control: Control): void {
        this.submit(control);
    }

    update(control: Control): void {
        this.submit(control);
    }

    insert(control: Control, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.SubmitAction(control, {persistable: true, restful: false}));
    }

    protected submit(control: Control): void {
        this.dispatch(new actions.SubmitAction(control));
        this.onAfterSubmit(control);
    }
    protected onAfterSubmit(control: Control): void {

        // ensure that the group referenced by the control has the control's id in its list
        this.appFacade.objects.group.store
            .getAll()
            .map(groups => groups.filter(group => group.id === control.group && !isInArray(control.id, group.controls)))
            .take(1)
            .subscribe(groups => {
                groups.forEach(group => this.appFacade.objects.group.store.attachControl(group, control));
            });

        // ensure that the group which reference the control, but the control does not reference the group (it has moved) does not have the control's id in its list
        this.appFacade.objects.group.store
            .getAll()
            .map(groups => groups.filter(group => group.id !== control.group && isInArray(control.id, group.controls)))
            .take(1)
            .subscribe(groups => {
                groups.forEach(group => this.appFacade.objects.group.store.detachControl(group, control));
            });
    }

    remove(control: Control, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(control, options));
    }

    setGroup(control: Control, group: Group): void {

        control = new Control({
            ...control,
            group: group.id
        });

        this.dispatch(new actions.SubmitAction(control));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.store-facade.ts